var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._t("default"),_c('div',{ref:"icon"},[_vm._t("icon")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }